import { cookieStorage } from '@muse-web/storages'

const CF_CHALLENGE_PARAM = '__cf_chl_tk'
const CF_ORIG_REF_COOKIE = 'cf_orig_ref'

/**
 * Returns the effective referrer URL, recovering the original referrer when the
 * user passed through a Cloudflare Managed Challenge (the challenge page overwrites
 * document.referrer). The original referrer is stored in the cf_orig_ref cookie by
 * the custom challenge page template.
 */
export const getClientReferrer = (): string => {
    try {
        // 1. Initial landing: CF token is in the current URL
        if (new URLSearchParams(window.location.search).has(CF_CHALLENGE_PARAM)) {
            const origRef = cookieStorage.get(CF_ORIG_REF_COOKIE)
            if (origRef) {
                return decodeURIComponent(origRef)
            }
        }

        // 2. Next page: CF token is in document.referrer
        const referrerUrl = new URL(document.referrer)
        if (referrerUrl.searchParams.has(CF_CHALLENGE_PARAM)) {
            const origRef = cookieStorage.get(CF_ORIG_REF_COOKIE)
            if (origRef) {
                return decodeURIComponent(origRef)
            }
        }

        return document.referrer
    } catch {
        return ''
    }
}
